/* eslint-disable react/sort-comp */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  TextInput,
  Button,
  FormGroup,
  ComposedModal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  DropdownSkeleton
} from 'carbon-components-react';
import SimpleReactValidator from 'simple-react-validator';
import { v4 as uuid } from 'uuid';
import { FindGHRSEmployer } from '../common/FindGHRSEmployer';
import { ComboBox } from '../../helpers/ComboBox';
import { DateFormat, entitiesLabels } from '../../helpers/Constants';
import { showNotification } from '../../helpers/notification/BaseNotification';
import DateTimePicker from '../../helpers/DateTimePicker';
import { FindSaipemCompilers } from '../common/FindSaipemCompilers';

export default class CARModal extends Component {
  incidentCARModel = (props) => {
    if (props.isEditModal) {
      const { editModel } = props;
      if (editModel.directCauseSubCategory) {
        editModel.idDirectCause = editModel.idDirectCause;
        
      }
      if (editModel.rootCauseSubCategory) {
        editModel.idRootCause = editModel.idRootCause;
      }
      return { ...editModel };
    }

    return {
      id: undefined, // guid
      idIncident: null, // guid
      idStatus: 0, // int
      status: null,
      dueDate: null,
      idOwner: null, // idEmployer: null,  //guid
      owner: {
        // employer: {
        id: null, // guid
        // name: '',
        // surname: '',
        // email: '',
      },
      idOwnerSaipem: null, // idEmployer: null,  //guid
      ownerSaipem: {
        // employer: {
        id: null, // guid
        // name: '',
        // surname: '',
        // email: '',
      },
      idDirectCauseSubCategory: null, // guid
      directCauseSubCategory: null, // {}
      idRootCauseSubCategory: null, // guid
      rootCauseSubCategory: null, // {}
      idRootCauseSubCategoryDetail: null, // guid
      rootCauseSubCategoryDetail: null, // {}
    };
  };

  constructor(props) {
    super(props);
    const owner = props.isEditModal
      ? props.editModel.owner || props.editModel.ownerSaipem
      : { id: null };
    this.validator = new SimpleReactValidator({autoForceUpdate: this, locale: 'en'});
    this.state = {
      model: {
        ...this.incidentCARModel(props),
      },
      owner,
      idIncident: this.props.idIncident,
      mode: props.mode || 0,
      appDirectCause: props.appDirectCause,
      appDirectCauseSubCategory: null,
      appRootCause: props.appRootCause,
      appRootCauseSubCategory: null,
      appRootCauseSubCategoryDetail: null,
    };
  }

  componentDidMount() {
    if (this.props.isEditModal) {
      // loading valori combo calcolate,
      if (this.state.model.idDirectCause) {
        this.getDirectCauseSubCategory(this.state.model.idDirectCause);
      }
      if (this.state.model.idRootCause) {
        this.getRootCauseSubCategory(this.state.model.idRootCause);
      }
    } else {
      //RITM0623666
      if(this.props.incidentCompiler) this.setSaipemOwner(this.props.incidentCompiler)
    }
  }
  
  getDirectCauseSubCategory(value) {
    this.setState({
      appDirectCauseSubCategory: this.props.appDirectCauseSubCategory.filter(
        (el) => el.idDirectCause === value
      ),
    });
  }

  getRootCauseSubCategory(value) {
    this.setState({
      appRootCauseSubCategory: this.props.appRootCauseSubCategory.filter(
        (el) => el.idRootCause === value
      ),
    });
  }

  getRootCauseSubCategoryDetail(value) {
    this.setState({
      appRootCauseSubCategoryDetail: this.props.appRootCauseSubCategoryDetail.filter(
        (el) => el.idRootCauseDetail === value
      ),
    });
  }

  handleChangeMode = (m) => {
    this.setState({ mode: m });
  };

  updateState = (inputName, inputValue, objName) => {
    const statusCopy = { ...this.state };
    statusCopy[objName][inputName] = inputValue;

    this.setState(statusCopy);
  };

  updateStateDP = (inputName, inputValue, objName) => {
    this.setState(
      (prevState) => ({
        [objName]: {
          ...prevState[objName],
          [inputName]: inputValue,
        },
      }),
      () => {
        this.incidentCARModel(inputName, inputValue);
      }
    );
  };

  handleChangeCombo = (inputName, selectedItem, objName) => {
    const inputValue = selectedItem ? selectedItem.id : null;
    const statusCopy = { ...this.state };

    statusCopy[objName][inputName] = inputValue;
    this.setState(statusCopy);
  };

  handleChangeComboType = (inputName, selectedItem, objName) => {
    const inputValue = selectedItem ? selectedItem.id : null;

    const statusCopy = { ...this.state[objName] };
    statusCopy[inputName] = inputValue;
    statusCopy.idDirectCauseSubCategory = null;

    this.setState({ [objName]: statusCopy }, () => {
      this.loadRelatedProperties(inputName, inputValue, selectedItem);
    });
  };

  handleChangeComboTypeRoot = (inputName, selectedItem, objName) => {
    const inputValue = selectedItem ? selectedItem.id : null;

    const statusCopy = { ...this.state[objName] };
    statusCopy[inputName] = inputValue;
    statusCopy.idRootCauseSubCategory = null;

    this.setState({ [objName]: statusCopy }, () => {
      this.loadRelatedProperties(inputName, inputValue, selectedItem);
    });
  };

  handleChangeComboTypeRootSub = (inputName, selectedItem, objName) => {
    const inputValue = selectedItem ? selectedItem.id : null;

    const statusCopy = { ...this.state[objName] };
    statusCopy[inputName] = inputValue;

    this.setState({ [objName]: statusCopy }, () => {
      this.loadRelatedProperties(inputName, inputValue, selectedItem);
    });
  };

  loadRelatedProperties = (inputName, inputValue) => {
    if (inputName === 'idRootCause') {
      if (inputValue) this.getRootCauseSubCategory(inputValue);
      else {
        this.setState({
          appRootCauseSubCategory: null,
        });
      }
    }

    if (inputName === 'idDirectCause') {
      if (inputValue) this.getDirectCauseSubCategory(inputValue);
      else {
        this.setState({
          appDirectCauseSubCategory: null,
        });
      }
    }

    if (inputName === 'idRootCauseSubCategory') {
      if (inputValue) this.getRootCauseSubCategoryDetail(inputValue);
      else {
        this.setState({
          getRootCauseSubCategoryDetail: null,
        });
      }
    }
  };

  setEmployer = (employer) => {
    if (employer && employer.id) {
      const statusCopy = { ...this.state.model };
      statusCopy.idOwner = employer.id;
      statusCopy.owner = employer;
      statusCopy.idOwnerSaipem = null;
      statusCopy.ownerSaipem = null;
      this.setState({ model: statusCopy, mode: 0, owner: employer });
    }
  };

  setSaipemOwner = (employer) => {
    if (employer && employer.id) {
      const statusCopy = { ...this.state.model };
      statusCopy.idOwnerSaipem = employer.id;
      statusCopy.ownerSaipem = employer;
      statusCopy.idOwner = null;
      statusCopy.owner = null;

      this.setState({ model: statusCopy, mode: 0, owner: employer });
    }
  };

  save = () => {
    if (this.validator.allValid()) {
      const { model } = this.state;
      if (!this.props.editModel) {
        model.id = uuid();
      }else{

        model.directCauseSubCategory = this.state.appDirectCauseSubCategory.find(el => el.id == model.idDirectCauseSubCategory);
        model.rootCauseSubCategory = this.state.appRootCauseSubCategory.find(el => el.id == model.idRootCauseSubCategory);
        model.closedOn= null;
      }
      this.props.save(model);
    } else {
      this.validator.showMessages();
      showNotification.warning(`${entitiesLabels.WARNING}`,`${entitiesLabels.CAR} required fields are missing  `);
      this.forceUpdate();
    }
  };

  clearAttachment = () => ({
		id: null, // guid
		fileIdentifier: null,
		name: null,
		contentType: null,
		size: null,
		type: null,
	});

  onUploadFiles = (fileIdentifier, fileName, fileType, size) => {
    const attachment = { ...this.state.attachment };

    attachment.id = uuid();
    attachment.fileIdentifier = fileIdentifier.blobName;
    attachment.name = fileName;
    attachment.contentType = fileType;
    attachment.size = size;
    // attachment.filePath = file.localPath;

    this.setState({
      attachment: this.clearAttachment(),
    });

    try {
      if (attachment == null) return;
      // insert
      const oldattachment = this.state.model.attachment || [];

      const newItem = {
        id: uuid(), // guid

        idAttachment: attachment.id, // guid
        attachment,
      };

      const newattachment = oldattachment.concat([newItem]);
      this.setState({model: {...this.state.model, attachment: newattachment}})
    } catch (error) {
      showNotification.error();
    }
  };

  onRemoveFile = (id) => {
    if (!id) return;
    const statusCopy = { ...this.state.model };
    statusCopy.attachment = statusCopy.attachment.filter((el) => el.id !== id);
    this.setState({model: statusCopy});
  };


  render() {
    const validations = {
      // immediateActions: this.validator.message('immediateActions', this.state.hocCardModel.immediateActions, 'required'),
      idDirectCause: this.validator.message(
        'DirectCause',
        this.state.model.idDirectCause,
        'required'
      ),
      idDirectCauseSubCategory: this.validator.message(
        'DirectCauseSubCategory',
        this.state.model.idDirectCauseSubCategory,
        'required'
      ),
      idRootCause: this.validator.message('RootCause', this.state.model.idRootCause, 'required'),
      idRootCauseSubCategory: this.validator.message(
        'RootCauseSubCategory',
        this.state.model.idRootCauseSubCategory,
        'required'
      ),
      //    idRootCauseSubCategoryDetail: this.validator.message('RootCauseSubCategoryDetail', this.state.model.idRootCauseSubCategoryDetail, 'required'),
      dueDate: this.validator.message('dueDate', this.state.model.dueDate, 'required'),
      //RITM0623666
      // idOwner: this.validator.message('Owner', this.state.owner.id, 'required'),
    };
    const modalHeader = {
      title: this.props.isEditModal ? 'Edit ' : 'Add new ',
      iconDescription: 'Close',
      buttonOnClick: () => this.props.toggleModal(false),
    };
    const { title, isOpenModal } = this.props;

    const selectedItemCombo = {
      idStatus: (this.props.appStatus || []).find(
        (el) => el.id === (this.state.model.idStatus > 0 ? this.state.model.idStatus : 1)
      ),
      idDirectCause: (this.state.appDirectCause || []).find(
        (el) => el.id === this.state.model.idDirectCause
      ),
      idDirectCauseSubCategory: this.state.appDirectCauseSubCategory
        ? (this.state.appDirectCauseSubCategory || []).find(
            (el) => el.id === this.state.model.idDirectCauseSubCategory
          )
        : null,
      idRootCause: this.state.appRootCause
        ? (this.state.appRootCause || []).find((el) => el.id === this.state.model.idRootCause)
        : null,
      idRootCauseSubCategory: (this.state.appRootCauseSubCategory || []).find(
        (el) => el.id === this.state.model.idRootCauseSubCategory
      ),
      idRootCauseSubCategoryDetail: (this.state.appRootCauseSubCategoryDetail || []).find(
        (el) => el.id === this.state.model.idRootCauseSubCategoryDetail
      ),
    };

    if (this.state.mode === 1) {
      return (
        <FindGHRSEmployer
          isOpenModal={isOpenModal}
          onCancel={() => this.handleChangeMode(0)}
          onOk={this.setEmployer}
        />
      );
    }
    if (this.state.mode === 2) {
      return (
        <FindSaipemCompilers
          isOpenModal={isOpenModal}
          url={`/incident/${this.state.idIncident}/car/compilers/`}
          onCancel={() => this.handleChangeMode(0)}
          onOk={this.setSaipemOwner}
        />
      );
    }
    return (
      <ComposedModal
        className="light-modal"
        open={isOpenModal}
        danger="false"
        onClose={() => false}
      >
        <ModalHeader className="margin-modal" {...modalHeader}>
          <p>{title || ''}</p>
        </ModalHeader>
        <ModalBody className="margin-modal">
          <div className="bx--grid--full-width">
            <div className="bx--row">
              <div className="bx--col-md-4 bx--col-lg-6">
                <FormGroup legendText="Direct Cause Category *">
                  {this.state.appDirectCause == null ? (
                    <DropdownSkeleton />
                  ) : (
                    <ComboBox
                      id="idDirectCause"
                      placeholder="Select"
                      name="idDirectCause"
                      alt="model"
                      onChange={this.handleChangeComboType}
                      itemToString={(item) => (item ? item.name : '')}
                      initialSelectedItem={selectedItemCombo.idDirectCause}
                      items={this.state.appDirectCause}
                      invalid={validations.idDirectCause != null}
                    />
                  )}
                  {validations.idDirectCause}
                </FormGroup>
              </div>
              <div className="bx--col-md-4 bx--col-lg-6">
                <FormGroup legendText="Direct Cause Sub-Category *">
                  <ComboBox
                    id="idDirectCauseSubCategory"
                    key= {selectedItemCombo.idDirectCauseSubCategory+'idDirectCauseSubCategory'}
                    placeholder="Select"
                    name="idDirectCauseSubCategory"
                    alt="model"
                    onChange={this.handleChangeCombo}
                    itemToString={(item) => (item ? item.name : '')}
                    initialSelectedItem={
                      selectedItemCombo.idDirectCauseSubCategory
                        ? selectedItemCombo.idDirectCauseSubCategory
                        : {}
                    }
                    items={this.state.appDirectCauseSubCategory}
                    disabled={this.state.appDirectCauseSubCategory == null}
                    invalid={validations.idDirectCauseSubCategory != null}
                  />
                  {validations.idDirectCauseSubCategory}
                </FormGroup>
              </div>
              <div className="bx--col-md-4 bx--col-lg-6">
                <FormGroup legendText="Root Cause Category *">
                  {this.state.appRootCause == null ? (
                    <DropdownSkeleton />
                  ) : (
                    <ComboBox
                      id="idRootCause"
                      key= {selectedItemCombo.idRootCause+'idRootCause'}
                      placeholder="Select"
                      name="idRootCause"
                      alt="model"
                      onChange={this.handleChangeComboTypeRoot}
                      itemToString={(item) => (item ? item.name : '')}
                      initialSelectedItem={
                        selectedItemCombo.idRootCause ? selectedItemCombo.idRootCause : {}
                      }
                      items={this.state.appRootCause}
                      invalid={validations.idRootCause != null}
                    />
                  )}
                  {validations.idRootCause}
                </FormGroup>
              </div>
              <div className="bx--col-md-4 bx--col-lg-6">
                <FormGroup legendText="Root Cause Sub-Category *">
                  <ComboBox
                    id="idRootCauseSubCategory"
                    placeholder="Select"
                    key= {selectedItemCombo.idRootCauseSubCategory+'idRootCauseSubCategory'}
                    name="idRootCauseSubCategory"
                    alt="model"
                    onChange={this.handleChangeComboTypeRootSub}
                    itemToString={(item) => (item ? item.name : '')}
                    initialSelectedItem={
                      selectedItemCombo.idRootCauseSubCategory
                        ? selectedItemCombo.idRootCauseSubCategory
                        : {}
                    }
                    items={this.state.appRootCauseSubCategory}
                    disabled={this.state.appRootCauseSubCategory == null}
                    invalid={validations.idRootCauseSubCategory != null}
                  />
                  {validations.idRootCauseSubCategory}
                </FormGroup>
              </div>
              <div className="bx--col-md-4 bx--col-lg-6">
                <FormGroup legendText="Root Cause Sub-Category Detail">
                  <ComboBox
                    id="idRootCauseSubCategoryDetail"
                    placeholder="Select"
                    name="idRootCauseSubCategoryDetail"
                    alt="model"
                    onChange={this.handleChangeCombo}
                    itemToString={(item) => (item ? item.name : '')}
                    initialSelectedItem={selectedItemCombo.idRootCauseSubCategoryDetail}
                    items={this.state.appRootCauseSubCategoryDetail}
                    disabled={this.state.appRootCauseSubCategoryDetail == null}
                  />
                  {/* validations.idRootCauseSubCategoryDetail */}
                </FormGroup>
              </div>

              <div className="bx--col-lg-6 bx--col-md-4">
                <FormGroup legendText="Due Date*">
                  <DateTimePicker
                    value={this.state.model.dueDate}
                    type="date"
                    placeholder={DateFormat}
                    name="dueDate"
                    alt="model"
                    invalid={validations.dueDate != null}
                    onChange={this.updateStateDP}
                    disabled={this.state.isDisabled}
                  />

                  {validations.dueDate}
                </FormGroup>
              </div>

              {/* <div className="bx--col-md-6 bx--col-lg-6">
                <FormGroup legendText="Actual date of completion of CAR">
                  {!this.state.model ? (
                    <DatePickerSkeleton />
                  ) : (
                    <DateTimePicker
                      value={this.state.model?.actualDateCompletition}
                      type="date"
                      disableFutureDate
                      placeholder={DateFormat}
                      name="actualDateCompletition"
                      alt="model"
                      onChange={this.updateState}
                    />
                )}
                </FormGroup>
              </div> */}

              {/* <div className="bx--col-lg-6 bx--col-md-6">
                                        <FormGroup legendText="Status*">
                                            {
                                                this.props.appStatus == null ?
                                                    <DropdownSkeleton />
                                                    :
                                                    <ComboBox
                                                        id="idStatus"
                                                        placeholder="Select"
                                                        name="idStatus"
                                                        alt="model"
                                                        //onChange={this.handleChangeCombo}
                                                        itemToString={item => (item ? item.reportingName : '')}
                                                        initialSelectedItem={selectedItemCombo.idStatus}
                                                        items={this.props.appStatus}
                                                        disabled={true}
                                                    />
                                            }
                                        </FormGroup>
                                    </div> */}
              {/* RITM0623666 */}
              {/* <div className="bx--col-lg-6 bx--col-md-8">
                <FormGroup legendText="Find Owner on GHRS or Saipem*">
                  <div className="bx--row two-button-center">
                    <div className="bx--col-lg-6 bx--col-md-6">
                      <Button
                        kind="primary"
                        className="bx--col"
                        onClick={() => this.handleChangeMode(1)}
                      >
                        GHRS research
                      </Button>
                    </div>
                    <div className="bx--col-lg-6 bx--col-md-6">
                      <Button
                        kind="primary"
                        className="bx--col"
                        onClick={() => this.handleChangeMode(2)}
                      >
                        Saipem research
                      </Button>
                    </div>
                  </div>
                  {validations.idOwner}
                </FormGroup>
              </div> */}
              {/* FINE  RITM0623666*/}
              <div className="bx--col-lg-6 bx--col-md-4">
                <FormGroup legendText="Owner Name">
                  <TextInput
                    id="txt-name"
                    name="txt-name"
                    placeholder=""
                    value={this.state.owner.name || ''}
                    type="text"
                    hideLabel
                    labelText=""
                    disabled
                  />
                </FormGroup>
              </div>
              <div className="bx--col-lg-6 bx--col-md-4">
                <FormGroup legendText="Owner Surname">
                  <TextInput
                    id="txt-surname"
                    name="txt-surname"
                    placeholder=""
                    value={this.state.owner.surname || ''}
                    // onChange={this.handleChangeModel}
                    type="text"
                    hideLabel
                    labelText=""
                    disabled
                  />
                </FormGroup>
              </div>
              <div className="bx--col-lg-6 bx--col-md-4">
                <FormGroup legendText="Owner Badge Number or email">
                  <TextInput
                    id="txt-badgeNumber"
                    name="txt-badgeNumber"
                    placeholder=""
                    value={this.state.owner.ghrS_ID || this.state.owner.email || ''}
                    // onChange={this.handleChangeModel}
                    type="text"
                    hideLabel
                    labelText=""
                    disabled
                  />
                </FormGroup>
              </div>
            </div>
            {}
          </div>
        </ModalBody>
        <ModalFooter>
          <Button kind="secondary" onClick={() => this.props.toggleModal(false)}>
            Cancel
          </Button>
          <Button kind="primary" onClick={() => this.save()}>
            Save
          </Button>
        </ModalFooter>
      </ComposedModal>
    );
  }
}

CARModal.propTypes = {
  save: PropTypes.func.isRequired,
  toggleModal: PropTypes.func.isRequired,
  isEditModal: PropTypes.bool,
  isOpenModal: PropTypes.bool,
  mode: PropTypes.number,
  title: PropTypes.string,
  appStatus: PropTypes.array,
};
